import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-5140">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-5141">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-5142">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-5143">
            <ArrowLeft className="w-4 h-4" data-id="element-5144" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-5145">NOIZA</div>
          <div className="w-20" data-id="element-5146" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-5147">
        <div className="mb-12" data-id="element-5148">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-5149">
            <FileText className="w-6 h-6 text-white/80" data-id="element-5150" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-5151">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-5152">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-5153">
          <section data-id="element-5154">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5155">
              <span className="text-[#006847]" data-id="element-5156">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5157">
              <p data-id="element-5158">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-5159">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5160">
                <li data-id="element-5161">Haber leído íntegramente este documento</li>
                <li data-id="element-5162">Comprender su contenido en su totalidad</li>
                <li data-id="element-5163">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-5164">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-5165">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5166">
              <span className="text-[#006847]" data-id="element-5167">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5168">
              <p data-id="element-5169">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5170">
                <li data-id="element-5171">Software como servicio (SaaS)</li>
                <li data-id="element-5172">Marketplace digital gastronómico</li>
                <li data-id="element-5173">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-5174">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5175">
                <li data-id="element-5176">Mostrar su menú digital</li>
                <li data-id="element-5177">Recibir pedidos de clientes</li>
                <li data-id="element-5178">Gestionar su operación interna</li>
                <li data-id="element-5179">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-5180">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-5181">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5182">
              <span className="text-[#006847]" data-id="element-5183">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5184">
              <p data-id="element-5185">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5186">
                <li data-id="element-5187">No es proveedor de alimentos</li>
                <li data-id="element-5188">No participa en la preparación de productos</li>
                <li data-id="element-5189">No manipula alimentos en ningún momento</li>
                <li data-id="element-5190">No realiza entregas ni logística</li>
                <li data-id="element-5191">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-5192">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-5193">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-5194">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5195">
              <span className="text-[#006847]" data-id="element-5196">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-5197">
              <p data-id="element-5198">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-5199">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5200">
                <li data-id="element-5201">El restaurante es el único responsable de su operación</li>
                <li data-id="element-5202">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-5203">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-5204">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5205">
                <li data-id="element-5206">Precios</li>
                <li data-id="element-5207">Menú</li>
                <li data-id="element-5208">Horarios</li>
                <li data-id="element-5209">Métodos de pago</li>
                <li data-id="element-5210">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5211">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5212">
              <span className="text-[#006847]" data-id="element-5213">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-5214">
              <div data-id="element-5215">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5216">
                  5.1. Alcance general
                </h3>
                <p data-id="element-5217">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-5218">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5219">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-5220">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5221">
                  <li data-id="element-5222">Calidad de los alimentos</li>
                  <li data-id="element-5223">Estado, frescura o preparación</li>
                  <li data-id="element-5224">Ingredientes utilizados</li>
                  <li data-id="element-5225">Contaminación cruzada</li>
                  <li data-id="element-5226">Problemas de higiene o salubridad</li>
                  <li data-id="element-5227">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5228">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-5229">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5230">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-5231">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5232">
                  <li data-id="element-5233">Retrasos en la entrega</li>
                  <li data-id="element-5234">Pérdida de pedidos</li>
                  <li data-id="element-5235">Entregas incompletas</li>
                  <li data-id="element-5236">Errores en dirección</li>
                  <li data-id="element-5237">Conducta de repartidores</li>
                  <li data-id="element-5238">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-5239">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5240">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-5241">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-5242">
                  <li data-id="element-5243">Recepción de pagos</li>
                  <li data-id="element-5244">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-5245">Manejo de efectivo</li>
                  <li data-id="element-5246">Confirmación de pagos</li>
                  <li data-id="element-5247">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-5248">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5249">
                  <li data-id="element-5250">Pagos no recibidos</li>
                  <li data-id="element-5251">Comprobantes falsos</li>
                  <li data-id="element-5252">Errores en montos</li>
                  <li data-id="element-5253">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-5254">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5255">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-5256">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5257">
                  <li data-id="element-5258">Reclamos de clientes</li>
                  <li data-id="element-5259">Reembolsos</li>
                  <li data-id="element-5260">Cancelaciones</li>
                  <li data-id="element-5261">Disputas</li>
                  <li data-id="element-5262">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5263">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-5264">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5265">
              <span className="text-[#006847]" data-id="element-5266">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-5267">
              <p data-id="element-5268">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5269">
                <li data-id="element-5270">Responsable</li>
                <li data-id="element-5271">Legal</li>
                <li data-id="element-5272">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-5273">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5274">
                <li data-id="element-5275">Publicar información falsa</li>
                <li data-id="element-5276">Manipular precios de forma engañosa</li>
                <li data-id="element-5277">Simular disponibilidad inexistente</li>
                <li data-id="element-5278">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5279">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5280">
              <span className="text-[#006847]" data-id="element-5281">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-5282">
              <p data-id="element-5283">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5284">
                <li data-id="element-5285">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-5286">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-5287">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5288">
                <li data-id="element-5289">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-5290">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-5291">
                    <li data-id="element-5292">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-5293">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-5294">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5295">
              <span className="text-[#006847]" data-id="element-5296">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-5297">
              <p data-id="element-5298">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5299">
                <li data-id="element-5300">Menú digital</li>
                <li data-id="element-5301">Gestión de pedidos</li>
                <li data-id="element-5302">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-5303">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5304">
                  <p className="font-medium text-white mb-2" data-id="element-5305">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5306">
                    <li data-id="element-5307">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5308">
                  <p className="font-medium text-white mb-2" data-id="element-5309">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5310">
                    <li data-id="element-5311">Propiedad del software</li>
                    <li data-id="element-5312">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-5313">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-5314">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5315">
              <span className="text-[#006847]" data-id="element-5316">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5317">
              <p data-id="element-5318">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5319">
                <li data-id="element-5320">Disponibilidad continua</li>
                <li data-id="element-5321">Funcionamiento sin interrupciones</li>
                <li data-id="element-5322">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-5323">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5324">
                <li data-id="element-5325">Fallas técnicas</li>
                <li data-id="element-5326">Actualizaciones</li>
                <li data-id="element-5327">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-5328">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-5329">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5330">
              <span className="text-[#006847]" data-id="element-5331">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-5332">
              <p data-id="element-5333">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5334">
                <li data-id="element-5335">No está garantizada permanentemente</li>
                <li data-id="element-5336">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-5337">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5338">
                <li data-id="element-5339">Destacar o no restaurantes</li>
                <li data-id="element-5340">Modificar posiciones</li>
                <li data-id="element-5341">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5342">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5343">
              <span className="text-[#006847]" data-id="element-5344">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-5345">
              <p data-id="element-5346">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5347">
                <li data-id="element-5348">Cumplir con los pagos acordados</li>
                <li data-id="element-5349">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-5350">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5351">
                <li data-id="element-5352">Suspender el servicio</li>
                <li data-id="element-5353">Limitar funcionalidades</li>
                <li data-id="element-5354">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5355">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5356">
              <span className="text-[#006847]" data-id="element-5357">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5358">
              <p data-id="element-5359">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5360">
                <li data-id="element-5361">Incumplimiento de términos</li>
                <li data-id="element-5362">Uso indebido</li>
                <li data-id="element-5363">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-5364">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-5365">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5366">
              <span className="text-[#006847]" data-id="element-5367">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-5368">
              <p data-id="element-5369">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-5370">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-5371">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5372">
              <span className="text-[#006847]" data-id="element-5373">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-5374">
              <p data-id="element-5375">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5376">
                <li data-id="element-5377">Pérdidas económicas</li>
                <li data-id="element-5378">Daños indirectos</li>
                <li data-id="element-5379">Lucro cesante</li>
                <li data-id="element-5380">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5381">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5382">
              <span className="text-[#006847]" data-id="element-5383">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-5384">
              <p data-id="element-5385">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-5386">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5387">
              <span className="text-[#006847]" data-id="element-5388">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-5389">
              <p className="font-medium" data-id="element-5390">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-5391">
                <li data-id="element-5392">Ha leído este documento completo</li>
                <li data-id="element-5393">Comprende su alcance</li>
                <li data-id="element-5394">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}